export const DEAL_GRID_COLUMNS = [
  ["SrNo", "Sr No"], ["DealID", "Deal ID"], ["DealDate", "Deal Date"],
  ["ShipperName", "Shipper Name"], ["BuyerName", "Buyer Name"],
  ["NoOfContainer", "No Of Container"], ["ItemNames", "Item"],
  ["Price", "Price Status"], ["TotalQty", "Total Qty"],
  ["DealStatus", "Status"], ["PendingStatus", "Pending Status"], ["Action", "Action"]
].map(([key, label]) => ({ key, label }));
export const REQUIRED_COLUMNS = ["SrNo", "DealID", "Action"];
export const DEFAULT_COLUMNS = DEAL_GRID_COLUMNS.map(column => column.key);
export const normalizeColumns = value => {
  if (!Array.isArray(value)) return [...DEFAULT_COLUMNS];
  const selected = [...new Set(value.filter(key => DEFAULT_COLUMNS.includes(key)))];
  for (const key of REQUIRED_COLUMNS) if (!selected.includes(key)) selected.push(key);
  return selected;
};
